module.exports = __webpack_public_path__ + "static/media/setting.a3d9d207.png";